export const SAVECART_MODAL_SHOW = 'SAVECART_MODAL_SHOW';
export const SAVECART_MODAL_HIDE = 'SAVECART_MODAL_HIDE';
export const SAVECART_MODAL_UPDATE = 'SAVECART_MODAL_UPDATE';

export const showSaveCartModel = ()=>(dispatch) => { 
    dispatch({
        type: SAVECART_MODAL_SHOW,
        payload: {showSavecartPop: true}
      });
};
export const hideSaveCartModel = () => ({
    type: SAVECART_MODAL_HIDE,
    payload: {
        showSavecartPop:false
    }
})
export const updateSavedCart = (value) => ({
    type: SAVECART_MODAL_UPDATE,
    payload: {saveCartTitle: value}
})


export const updateSavedCartTitle = (value) => (dispatch) => {
    dispatch(updateSavedCart(value));
}

